// Adapt app links from reference material without rewriting help-center or external URLs.
// Replacing only the origin preserves paths, query strings, fragments, and Markdown formatting.
export const localizeAssistantUrls = (text: string, origin: string): string =>
  text.replace(/https?:\/\/(?:www\.)?zeffy\.com(?=[/?#\s)\]}>,"']|$)/gi, () => origin);
